<script>
    // import Swal from "sweetalert2";
    import Layout from "../../layouts/main";
    import appConfig from "../../../app.config";
    import Basic from "@/views/auditing-order/components/basic";
    // import Report from "@/views/auditing-order/components/report";
    import {
        editWorkOrder,
        auditingDetails,
        getRepairDetail,
        // patchOpportunity,
        // postOpportunityComment,
        auditingAssign,
        putAuditingDetails,
    } from "@/service";
    import {
        formatDatetime,
        toUtcFormat,
        getLabel
    } from "@/helpers/common";
    import WoStatusEtc from "@/views/auditing-order/components/widgets/wo-status-etc";
    import {
        alertComfirm,
        successMsg
    } from "@/helpers/swal";
    import _ from "lodash";
    import {
        WO_STATUS_TO_BE_ASSIGNED,
        WO_STATUS_TO_BE_CONSTRUCTED,
        WO_STATUS_COMPLETED,
        WO_STATUS_CANCELLED,
        BUSINESS_DELAY_REASON,
    } from "@/config/common";
    import {
        isWorkOrderToBeConfirmed,
        isWorkOrderUnderConstruction,
    } from "@/views/auditing-order/wo-status-op";
    import moment from "moment";
    import CancelModal from "@/views/auditing-order/components/widgets/cancel-modal";

    export default {
        page: {
            // title: "工单",
            meta: [{
                name: "description",
                content: appConfig.description,
            }]
        },
        data() {
            return {
                auditingAssignList: {},
                WO_STATUS_CANCELLED,
                workOrderId: null,
                detailLoaded: false,
                woData: {},
                checkTabVal: '1',
                tabOptions: [{
                        value: '1',
                        text: this.$t('page.basic-info')
                    },
                    {
                        value: '2',
                        text: this.$t('page.auditing.service_process'),//服务过程
                    },
                    {
                        value: '3',
                        text: this.$t('page.service-report.text')
                    },
                    // {
                    //   value: '4',
                    //   text: '工单日志'
                    // }
                ],
                deviceImg: null,
                checkins: [],
                cancelOrderObj: {
                    show: false,
                    title: this.$t('page.cancel_order'),
                    // 如果是商机转工单，需要显示取消原因
                    showCancelReason: false,
                    cancelReasonRequired: false,
                    cancelReasonList: [
                        ...BUSINESS_DELAY_REASON
                    ],
                },
                editType: false,
                tabStatus: '',
                pageNavTab: '' // 当前切换的哪个tab，如？基本信息、服务过程、服务报告
            }
        },

        mounted() {
            this.workOrderId = this.$route.params.id
            this.getDetail()
            this.getAuditingAssign()
        },

        computed: {
            permission() {
                return JSON.parse(localStorage.getItem("permission"));
            },
            showCancelBtn() {
                return [WO_STATUS_TO_BE_ASSIGNED, WO_STATUS_TO_BE_CONSTRUCTED].includes(parseInt(this.woData.status)) &&
                    this.permission.includes('auditing.role.sale')
            },
            showTransferBtn() {
                return !!isWorkOrderToBeConfirmed(this.woData);

            },
            showConfirmBtn() {
                return !!isWorkOrderToBeConfirmed(this.woData);

            },
            showCompleteBtn() {
                return !!isWorkOrderUnderConstruction(this.woData);

            },
            user() {
                return JSON.parse(localStorage.getItem("user"));
            },
            // 是否显示编辑按钮(技术可编辑，销售不可编辑)
            showEditOperateBtn() {
                // this.woData.status 工单状态：'1':'待施工','2':'施工中','3':'已完成','4':'已取消'
                // this.tabStatus ('1','执行中'), ('2','待审核'), ('3','待签字'), ('4','已完成')

                // this.user.user_type 类型如下: 
                // manufacturer:设备制造商，nash 技术服务工程师 
                // service_company：代理商
                // customer：终端客户
                // sale：销售服务工程师权限 
                if (this.pageNavTab !== '2' || this.editType || this.user.user_type === 'customer' || ['3', '4'].includes(this.woData.status)){
                    return false; // 客户不能编辑，只能看、已完成，已经取消的工单不能编辑
                } 

                if (this.hasSaleRolePermission) { // 有销售服务工程师权限
                    return ['1','2','3'].includes(this.tabStatus) // 销售人员执行中、待签字都可以编辑
                }
                return ['1'].includes(this.tabStatus) // 技术人员只能编辑执行中的单子
            },
            // 是否显示取消、保存按钮
            showSaveCancelOperateBtn() {
                return this.pageNavTab === '2' && this.editType && !['3', '4'].includes(this.woData.status)
            },
            // 是否有销售服务工程师权限
            hasSaleRolePermission() {
                return this.permission.includes('auditing.role.sale')
            }
        },
        methods: {
            formatDatetime,
            getLabel,
            getAuditingAssign() {
                auditingAssign(this.workOrderId).then(res => {
                    this.auditingAssignList = res.payload
                })
            },
            getDetail() {
                // console.log('id:', this.workOrderId)
                auditingDetails(this.$route.params.id).then(res => {
                    this.woData = res.payload
                    // 如果是服务请求转工单，查询请求信息
                    if (this.woData.service_request) {
                        getRepairDetail(this.woData.service_request).then(serviceRes => {
                            this.woData.serviceRequestData = serviceRes.payload
                            this.detailLoaded = true
                        })
                    } else {
                        this.detailLoaded = true
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            refresh() {
                this.getDetail()
                this.getAuditingAssign()
            },
            tabStatusChange(val) {
                this.tabStatus = val
                if (this.tabStatus == 4) {
                    this.editType = false
                }
            },
            checkinLoaded(checkins) {
                this.checkins = checkins
            },
            deviceLoaded(deviceInfo) {
                const imgs = _.get(deviceInfo, 'files.image', [])
                if (imgs.length > 0) {
                    this.deviceImg = imgs[0].url
                } else {
                    this.deviceImg = null
                }
            },
            // 取消工单
            cancelOrder() {
                this.cancelOrderObj.show = true
                if (this.woData.task_id) {
                    this.cancelOrderObj.showCancelReason = true
                    this.cancelOrderObj.cancelReasonRequired = true
                } else {
                    this.cancelOrderObj.showCancelReason = false
                    this.cancelOrderObj.cancelReasonRequired = false
                }
                // console.log(this.cancelOrderObj)
                // this.cancelOrderObj = JSON.parse(JSON.stringify(this.cancelOrderObj))
                // alertComfirm(this.$t('base.Confirm to perform this operation?'), this.$t('page.cancel-work-order')).then(confirm => {
                //   if (confirm) {
                //     const form = {
                //       id: this.woData.id,
                //       status: WO_STATUS_CANCELLED,
                //     }
                //     this.edit(form)
                //   }
                // })


            },
            // 取消工单确认
            cancelOrderConfirm({
                reason_desc
            }) {
                let params = {
                    status: 4,
                    remark: reason_desc
                }
                putAuditingDetails(this.woData.id, params).then(res => {
                    console.log(res)
                    successMsg(this.$t("base.operate_success"))
                    this.refresh()
                    this.cancelOrderObj.show = false

                })

            },
            // 申请转派
            transferOrder() {
                alertComfirm(this.$t('base.Confirm to perform this operation?'), this.$t('page.apply-reassign')).then(
                    confirm => {
                        if (confirm) {
                            const form = {
                                id: this.woData.id,
                                status: WO_STATUS_TO_BE_ASSIGNED,
                                main_engineer: null,
                                assist_engineer: null,
                                is_reassign: true,
                                is_confirm: false,
                                is_checkin: false,
                            }
                            // 清空签到记录
                            // this.checkins.forEach(checkin => {
                            //   deleteCheckin(checkin.id)
                            // })
                            this.edit(form)
                        }
                    })
            },
            // 派工确认
            confirmOrder() {
                alertComfirm(this.$t('base.Confirm to perform this operation?'), this.$t('page.dispatch-confirmation'))
                    .then(confirm => {
                        if (confirm) {
                            const form = {
                                id: this.woData.id,
                                status: WO_STATUS_TO_BE_CONSTRUCTED,
                                is_confirm: true,
                            }
                            this.edit(form)
                        }
                    })
            },
            // 完成工单
            completeOrder() {
                alertComfirm(this.$t('base.Confirm to perform this operation?'), this.$t('page.complete-work-order'))
                    .then(confirm => {
                        if (confirm) {
                            const form = {
                                id: this.woData.id,
                                status: WO_STATUS_COMPLETED,
                                complete_at: toUtcFormat(moment().format('YYYY-MM-DD HH:mm:ss'))
                            }
                            this.edit(form)
                        }
                    })
            },
            edit(params, goBackList = false) {
                editWorkOrder(params).then(() => {
                    if (goBackList) {
                        setTimeout(() => {
                            this.$router.push('/auditing-order')
                        }, 1000);
                    } else {
                        this.refresh()
                    }
                })
            },
            saveAuditing() {
                if (!this.$refs.basic.validate()) return // 提交前的校验
                this.editType = !this.editType
                // this.$refs.basic.postAuditingConverts(); /* 由于商机转换通过列表编辑操作，业务了。无需保存时提交，因此无需调起保存商机转换的接口了。 */
            },

        },
        components: {
            CancelModal,
            WoStatusEtc,
            Layout,
            Basic,
            // Report,
        }
    }
</script>
<template>
    <Layout>
        <b-row class="mb-sm-4">
            <b-col>
                <b-row>

                    <b-col>
                        <h4 class="mt-0-8 d-flex align-items-center">{{woData.number}} <wo-status-etc
                                field-name="priority" :value="woData.priority" custom-class="me-3"
                                custom-style="line-height: 1rem;font-size:12px" />
                            <wo-status-etc field-name="status" :value="woData.status" :wo-data="woData"
                                custom-style="line-height: 1rem;font-size:12px" />
                        </h4>
                        <div class="mt-0-8" v-if="woData.service_request">
                            {{ $t('page.relatedServiceRequest') }}：
                            <router-link
                                :to="'/repair-request/detail/' + woData['service_request']">{{ woData.service_request_number }}</router-link>
                        </div>
                        <div class="mt-0-8" style="line-height: 2rem;">
                            <span class="split-right-border"><svg xmlns="http://www.w3.org/2000/svg" width="13"
                                    height="13" viewBox="0 0 13 13" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M11.3743 10.2917H12.4577V11.375H0.541016V10.2917H1.62435V2.16667C1.62435 1.86751 1.86686 1.625 2.16602 1.625H7.58268C7.88184 1.625 8.12435 1.86751 8.12435 2.16667V10.2917H10.291V5.95833H9.20768V4.875H10.8327C11.1318 4.875 11.3743 5.11751 11.3743 5.41667V10.2917ZM2.70703 2.70825V10.2916H7.04036V2.70825H2.70703ZM3.79102 5.95825H5.95768V7.04159H3.79102V5.95825ZM3.79102 3.79175H5.95768V4.87508H3.79102V3.79175Z"
                                        fill="#212529" />
                                </svg> {{ woData.customer_txt }}</span>
                            <span>{{ $t('page.create_time') }}：</span>
                            <span>{{ formatDatetime(woData.created_at) }}</span>
                            <!--              <span>{{ $t('page.construction_time') }}：</span>-->
                            <!--              <span class="split-right-border">{{ formatDatetime(woData.plan_start_at) }}</span>-->

                        </div>
                        <div class="mt-0-8" style="line-height: 2rem;" v-if="woData.status == WO_STATUS_CANCELLED">
                            <span>{{ $t('page.reason_explain') }}：</span>
                            <span>{{ woData.remark }}</span>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" md="auto" class="text-end">
                <button type="button" v-if="(woData.status!='3'&&woData.status!='4')&&showCancelBtn"
                    class="me-2 mb-2 btn btn-outline-danger" @click="cancelOrder">{{ $t('page.cancel_order') }}</button>
                <button type="button" v-if="showEditOperateBtn" class="me-2 mb-2 btn btn-primary"
                    @click="editType=!editType">{{$t('base.edit')}}</button>
                <button type="button" v-if="showSaveCancelOperateBtn" class="me-2 mb-2 btn btn-info"
                    @click="editType=!editType">{{$t('base.cancel')}}</button>
                <button type="button" v-if="showSaveCancelOperateBtn" class="me-2 mb-2 btn btn-primary"
                    @click="saveAuditing">{{$t('base.save')}}</button>
            </b-col>
        </b-row>
        <div>
            <Basic ref="basic" :wo-data="woData" :editType="editType" @tabStatusChange="tabStatusChange" v-model:tabStatus="tabStatus"
                :auditingAssignList="auditingAssignList" @refresh="refresh" @checkinLoaded="checkinLoaded"
                @pageNavTabChange="(val)=>{pageNavTab=val}" />
        </div>

        <cancel-modal :title="cancelOrderObj.title" :show="cancelOrderObj.show"
            :show-cancel-reason="cancelOrderObj.showCancelReason"
            :cancel-reason-required="cancelOrderObj.cancelReasonRequired" @ok="cancelOrderConfirm"
            @cancel="cancelOrderObj.show = false"></cancel-modal>


    </Layout>
</template>